module.exports = __webpack_public_path__ + "img/youtube.2a697c5c.svg";